<template>
  <div>
    <el-form :inline="true" :model="formInline" ref="formInline">
      <el-form-item label="设备编号" prop="deviceId">
        <el-input v-model="formInline.deviceId" placeholder="设备编号"></el-input>
      </el-form-item>
      <el-form-item label="服务编号" prop="serviceNo">
        <el-input v-model="formInline.serviceNo" placeholder="服务批次"></el-input>
      </el-form-item>
      <el-form-item label="费用支付" prop="payState">
        <el-select v-model="formInline.payState" placeholder="请选择">
          <el-option label="未支付" value="0"></el-option>
          <el-option label="已支付" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search('formInline')">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button @click="reset('formInline')">重置</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="data" border stripe style="width: 100%">
      <el-table-column prop="deviceId" label="设备编号"> </el-table-column>
      <el-table-column prop="serviceNo" label="服务编号"> </el-table-column>
      <el-table-column prop="outBillNo" label="出库编号"> </el-table-column>
      <el-table-column prop="crm" label="CRM订单号"> </el-table-column>
      <el-table-column prop="referName" label="机构名称"> </el-table-column>
      <el-table-column prop="startTime" label="开始时间"> </el-table-column>
      <el-table-column prop="endTime" label="结束时间"> </el-table-column>
      <el-table-column prop="statusName" label="服务状态"> </el-table-column>
    </el-table>
    <div class="tableDel-Page">
      <Pagination :params="pagin" @pageBind="getList"></Pagination>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
export default {
  data() {
    return {
      formInline: {
        deviceId: "",
        serviceNo: "",
        payState: "",
      },
      data: [ ],
      pagin: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
    };
  },
  methods: {
    search(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.pagin.pageNum = 1;
          this.getList();
        }
      });
    },
    getList() {
      //数据绑定
      let params = {
        pageNum: this.pagin.pageNum,
        pageSize: this.pagin.pageSize,
        ...this.formInline
      };
      this.$http
        .post("/manage/outService/listPageOutServiceDevice", params)
        .then((results) => {
          this.data = results["data"]["data"]["records"];
          this.pagin.total = results["data"]["data"]["total"];
        });
    },
    reset(formName) {
      this.$refs[formName].resetFields();
      this.pagin.pageNum = 1;
      this.getList();
    },
  },
  components: { Pagination },
};
</script>
